// Modules
import axios from "axios";
import moment from "moment";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";

// CSS
import '_Asset/css/Admin/Page/admin.css'

// API
import { AdFaqApi, AdFaqSgApi } from "_Route/Api";
import DefaultCKEditor from "Admin/Component/DefaultCKEditor";


const AdFAQDt = () => {

  // Using Hooks
  const params = useParams();
  const navigate = useNavigate();

  const sessionID = localStorage.getItem('memSessionID')
  const userScore = useSelector(state => state.authorityAcc.access_score);
  const userName = useSelector(state => state.authorityAcc.name);
  const master = useSelector(state => state.authorityAcc.master);

  const curType = params.id === 'add' ? '등록' : '수정';
  const curScore = params.id === 'add' ? 200 : 300;
  const useGroup = ['미사용', '사용'];

  const [useIdx, setUseIdx] = useState(1);
  const [info, setInfo] = useState({
    faq_title: '',
    faq_content: undefined,
    approve_spec_status: 0,
    approve_ap_status: 0,
  })
  const { faq_title, faq_content } = info;
  const curDate = moment(new Date()).format('YYYY-MM-DD HH:mm');

  
  
  const onChange = (e) => {
    const { name, value } = e.target;
    setInfo({...info, [name]: value});
  }


  // Set Current FAQ List
  useEffect(() => {
    if (curType === '수정') {
      axios.get(AdFaqSgApi, {
        headers: {
          "Content-Type": "application/json",
          'Authorization': sessionID,
        },
        params: {
          faq_uuid: params.id
        }
      })
      .then(res => {
        const curFaq = res.data.result[0]
        if(curFaq === undefined && params.id !== 'add') {
          navigate('/404');
        }

        setUseIdx(curFaq.faq_use);
        setInfo({faq_title: curFaq.faq_title, faq_content: curFaq.faq_content})
      })
      .catch(err => {
        console.error(err, "GET FAQ Data Error...");
      })
    }
  }, [])

  // FAQ Axios 
  const postFAQ = () => {
    if(faq_title === '') { alert("제목을 입력해주세요.") }
    else if (faq_content === '' || faq_content === undefined) { alert("내용을 입력해주세요.") }
    else {
      axios({
        url: AdFaqApi,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          'Authorization': sessionID,
        },
        data: {
          faq_use: useIdx,
          faq_title: faq_title,
          faq_content: faq_content,
          faq_create_user: userName,
          approve_spec_status: 0,
          approve_ap_status: 0,
        }
      })
      .then(res => {
        alert(`FAQ 등록${master === 1 ? '' : ' 요청'}을 완료하였습니다.`)
        navigate('/admin/faq/list')
      })
      .catch(err => {
        console.error(err, `FAQ POST Error..`)
        const errMsg = err.response.data.message
        if (errMsg) { alert(errMsg) }
      })
    }
  }

  const updateFAQ = () => {
    if(faq_title === '') { alert("제목을 입력해주세요.") }
    else if (faq_content === '' || faq_content === undefined) { alert("내용을 입력해주세요.") }
    else {
      axios({
        url: AdFaqApi,
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          'Authorization': sessionID,
        },
        data: {
          faq_uuid: params.id,
          faq_use: useIdx,
          faq_title: faq_title,
          faq_content: faq_content,
          faq_create_user: userName,
          faq_last_modify_user: userName,
          approve_spec_status: 0,
          approve_ap_status: 0,
        }
      })
      .then(res => {
        alert(`FAQ 수정${master === 1 ? '' : ' 요청'}을 완료하였습니다.`)
        navigate('/admin/faq/list')
      })
      .catch(err => {
        console.error(err, "FAQ PUT Error..")
        const errMsg = err.response.data.message
      if (errMsg) { alert(errMsg) }
      })
    }
  }

  const deleteFAQ = () => {
    axios({
      url: AdFaqApi,
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        'Authorization': sessionID,
      },
      data: {
        faq_uuid: params.id,
        approve_spec_status: 0,
        approve_ap_status: 0,
      }
    })
    .then(res => {
      alert(`FAQ 삭제${master === 1 ? '를' : ' 요청을'} 완료하였습니다.`)
      navigate('/admin/faq/list')
    })
    .catch(err => {
      console.error(err, "FAQ DELETE Error..")
      const errMsg = err.response.data.message
      if (errMsg) { alert(errMsg) }
    })
  }

  return (
    <>
      <div className="adContTitGroup">
        <h2>FAQ {curType}</h2>
        <p>Home / FAQ / FAQ {curType}</p>
      </div>

      <div className="adContArea detail">
        <fieldset className="left">
          <legend>FAQ 글 수정</legend>

          {/* 사용여부 [faq_use] */}
          <div className="fieldGroup row">
            <label>사용여부<span className="redTxt">*</span></label>

            <div className="field">
              {useGroup.map((item, i) =>
                <div className="checkGroup" key={i}>
                  <input type="radio" className="check sm blue" id={`faq_use_${i}`} onChange={() => setUseIdx(i)} checked={useIdx === i}/>
                  <label htmlFor={`faq_use_${i}`}></label>

                  <label htmlFor={`faq_use_${i}`}>{item}</label>
                </div>
              )}
            </div>
          </div>

          {/* 제목 [faq_title] */}
          <div className="fieldGroup row">
            <label>제목<span className="redTxt">*</span></label>

            <div className="field full">
              <input type="text" className="input md round_10" name="faq_title" value={faq_title} onChange={(e) => onChange(e)} placeholder="제목을 입력해주세요." />
            </div>
          </div>

          {/* 내용 [faq_content] */}
          <div className="fieldGroup row">
            <label>내용<span className="redTxt">*</span></label>

            <div className="field full">
              <DefaultCKEditor
                config={{placeholder: "내용을 입력하세요."}}
                data={faq_content}
                // onReady={(editor) => {
                //   uploadPlugin(editor, AdIncruitUploadApi, setFileName)
                // }}
                onChange={(event, editor) => {
                  {(faq_content || faq_content === "" || curType === "등록") &&
                  setInfo({
                    ...info,
                    faq_content: editor.getData()
                  })}
                }}
                // onBlur={() => onChangeFile()}
              />
            </div>
          </div>

          {/* 작성/수정자 */}
          <div className="fieldGroup row">
            <label>{curType}자</label>

            <div className="field full">
              <input type="text" className="input md round_10" value={userName} disabled />
            </div>
          </div>

          {/* 작성/수정 일시 */}
          <div className="fieldGroup row">
            <label>{curType} 일시</label>

            <div className="field full">
              <input type="text" className="input md round_10" value={curDate} disabled />
            </div>
          </div>
        </fieldset>

        <div className="btnArea">
          {
            userScore >= curScore &&
            <button type="button" className="btn sm sfrtBlue round_10" onClick={curType === '수정' ? updateFAQ : postFAQ}>{curType}{master === 1 ? '' : ' 요청'}</button>
          }
          <button type="button" className="btn sm blue_edge round_10" onClick={() => navigate('/admin/faq/list')}>취소</button>
          {curType === '수정' && userScore >= 300 && <button type="button" className="btn sm red round_10" onClick={() => {if(window.confirm(`정말 해당 게시물을 삭제하시겠습니까?`)) deleteFAQ() }}>{`삭제${master === 1 ? '' : ' 요청'}`}</button>}
        </div>
      </div>
    </>
  )
}

export default AdFAQDt;